import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a80eda48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-minted-token-inner" }
const _hoisted_2 = {
  key: 0,
  class: "spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "play",
  src: "@/assets/images/play.svg"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "m-minted-token-info" }
const _hoisted_8 = ["href"]

import { onBeforeMount, onMounted, reactive, ref } from "vue";
import { RevealedToken } from "@manifoldxyz/collectible-sdk";
import { useStore } from "@/composables/useStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'Token',
  props: {
    numberMinted: {},
    token: {}
  },
  setup(__props: any) {

const props = __props;



const store = useStore();

const componentState = reactive<{
  show: boolean;
  animationLoaded: boolean;
  imageLoaded: boolean;
  animationType: "video" | "iframe";
}>({
  show: false,
  animationLoaded: false,
  imageLoaded: false,
  animationType: "video",
});
const animationIframeRef = ref<HTMLIFrameElement | null>(null);
const imageRef = ref<HTMLImageElement | null>(null);
const animationRef = ref<HTMLImageElement | HTMLVideoElement | null>(null);

onBeforeMount(async () => {
  const img = document.createElement("img");
  img.src = props.token.image;
  const poll = setInterval(() => {
    if (img.naturalWidth) {
      clearInterval(poll);
      componentState.show = true;
    }
  }, 10);

  if (props.token.animation_url) {
    const resp = await fetch(props.token.animation_url, {
      method: "HEAD",
    });
    const contentType = resp.headers.get("Content-Type");

    if (contentType === "text/html") {
      componentState.animationType = "iframe";
    }

    setTimeout(() => {
      animationIframeRef.value!.addEventListener("load", () => {
        componentState.animationLoaded = true;
      });
    }, 10);
  }
});

onMounted(() => {
  if (animationIframeRef.value) {
    (animationIframeRef.value as HTMLElement).addEventListener("canplaythrough", () => {
      componentState.animationLoaded = true;
    });
  }
  if (imageRef.value) {
    (imageRef.value as HTMLElement).addEventListener("load", () => {
      componentState.imageLoaded = true;
    });
  }
});

const play = () => {
  if (animationRef.value) {
    (animationRef.value as HTMLVideoElement).play();
  }
};

const stop = () => {
  if (animationRef.value) {
    (animationRef.value as HTMLVideoElement).pause();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["manifold m-minted-token", { show: componentState.show }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "m-minted-token-media",
        onMouseenter: play,
        onMouseleave: stop
      }, [
        (!componentState.imageLoaded && !componentState.animationLoaded)
          ? (_openBlock(), _createElementBlock("i", _hoisted_2))
          : _createCommentVNode("", true),
        (props.token.animation_url && componentState.animationLoaded)
          ? (_openBlock(), _createElementBlock("i", _hoisted_3))
          : _createCommentVNode("", true),
        (
            props.token.animation_url &&
            componentState.animationType === 'video' &&
            props.numberMinted < 3
          )
          ? (_openBlock(), _createElementBlock("video", {
              key: 2,
              ref_key: "animationRef",
              ref: animationRef,
              class: _normalizeClass({ show: componentState.imageLoaded }),
              src: _ctx.token.animation_url
            }, null, 10, _hoisted_4))
          : (
            props.token.animation_url &&
            componentState.animationType === 'iframe' &&
            props.numberMinted < 3
          )
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 3,
                ref_key: "animationIframeRef",
                ref: animationIframeRef,
                class: _normalizeClass({ show: componentState.animationLoaded }),
                src: _ctx.token.animation_url,
                sandbox: "allow-scripts allow-same-origin allow-forms"
              }, null, 10, _hoisted_5))
            : _createCommentVNode("", true),
        _createElementVNode("img", {
          ref_key: "imageRef",
          ref: imageRef,
          class: _normalizeClass({ show: componentState.imageLoaded }),
          src: _ctx.token.image
        }, null, 10, _hoisted_6)
      ], 32),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", null, _toDisplayString(`${props.token.name}${_unref(store).isERC1155 ? ` (x${props.numberMinted})` : ""}`), 1),
        _createElementVNode("a", {
          href: props.token.openseaUrl,
          target: "_blank"
        }, "OpenSea", 8, _hoisted_8)
      ])
    ])
  ], 2))
}
}

})